//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "DocTypeBasedModel",
  props: {
    model: {
      type: Object,
      value: {}
    }
  },
  data: () => ({}),
  computed: {
    inputs() {
      const inputs = this.model.properties["ai_model:inputs"];
      return inputs.map(e => e.name);
    },

    outputs() {
      const outputs = this.model.properties["ai_model:outputs"];
      return outputs.map(e => e.name);
    },

    docType() {
      return this.model.properties["ai_model:doc_type"];
    }
  },
  methods: {
    openInNew() {
      this.$router.push({name: "model", params: {id: this.model.uid}});
      console.log(`Openning model ${this.docType} in a new tab/window`);
    },

    compare() {
      console.log(`Compareing ${this.docType} with others`);
    }
  }
};
